import React from 'react';
import { motion } from 'framer-motion';
import { Shield, CreditCard, Lock } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="relative pt-8 pb-12 md:pb-16 px-4 overflow-hidden" data-id="element-154">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-radial-gold pointer-events-none" data-id="element-155" />

      <div className="max-w-3xl mx-auto relative z-10 flex flex-col items-center text-center" data-id="element-156">
        {/* Logo & Brand */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="mb-8" data-id="element-157">
          <div className="flex items-center justify-center gap-2 mb-1" data-id="element-158">
            <div className="w-8 h-8 bg-gold-gradient rounded-lg flex items-center justify-center shadow-gold-glow" data-id="element-159">
              <Shield className="w-5 h-5 text-brand-dark" data-id="element-160" />
            </div>
            <h2 className="text-2xl font-montserrat font-bold tracking-wider text-white" data-id="element-161">
              AVANZAPRO<sup className="text-sm" data-id="element-162">®</sup>
            </h2>
          </div>
          <p className="text-gold/80 text-sm font-inter" data-id="element-163">www.avanzapro.store</p>
        </motion.div>

        {/* Tagline */}
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.2
      }} className="text-lg md:text-xl text-cream/90 font-medium mb-6" data-id="element-164">
          Todo lo que necesitás para salir del Clearing.
          <br data-id="element-165" />
          <span className="text-gold-gradient font-bold" data-id="element-166">
            Listo. Desde hoy.
          </span>
        </motion.p>

        {/* Main Headline */}
        <motion.h1 initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.3
      }} className="text-3xl sm:text-4xl md:text-6xl font-black leading-tight mb-8 uppercase" data-id="element-167">
          SISTEMA LIBRE DE <br data-id="element-168" />
          <span className="text-gold-gradient" data-id="element-169">CLEARING</span>
        </motion.h1>

        {/* Product Image */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="relative w-full max-w-2xl mb-10" data-id="element-170">
          <div className="absolute inset-0 bg-gold/20 blur-[100px] rounded-full" data-id="element-171" />
          <img src="https://cdn.magicpatterns.com/uploads/4qCec4kTmad9hekPeXDASf/ChatGPT_Image_9_may_2026,_05_32_48_p.m..png" alt="Sistema Libre de Clearing Megapack" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-172" />
        </motion.div>

        {/* Subheadline */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5
      }} className="max-w-2xl mb-10" data-id="element-173">
          <p className="text-lg md:text-xl text-cream leading-relaxed font-medium" data-id="element-174">
            El sistema N°1 de autogestión crediticia para uruguayos — Deudas
            viejas → Historial limpio →{' '}
            <span className="text-gold font-bold" data-id="element-175">
              Libertad financiera real
            </span>
          </p>
          <p className="mt-4 text-cream/80 text-sm md:text-base" data-id="element-176">
            Cartas legales + protocolos + guiones de negociación listos para
            usar. Sin abogados. Sin trámites complicados. Sin pagar de más.
          </p>
        </motion.div>

        {/* Badges */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.6
      }} className="flex flex-wrap justify-center gap-3 mb-10" data-id="element-177">
          {['📄 100% PDF', '⚡ Acceso en 5 min', '🇺🇾 Para Uruguay', '📚 6 Tomos', '🎁 6 Bonos incluidos', '✅ Plantillas legales'].map((badge, i) => <span key={i} className="bg-brand-light border border-gold/20 px-4 py-2 rounded-full text-sm font-medium text-cream shadow-sm" data-id="element-178">
              {badge}
            </span>)}
        </motion.div>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.7
      }} className="w-full max-w-md mx-auto" data-id="element-179">
          <CTAButton data-id="element-180">→ QUIERO MI MEGAPACK AHORA</CTAButton>

          {/* Trust indicators */}
          <div className="flex justify-center items-center gap-4 mt-6 text-xs text-cream/70" data-id="element-181">
            <div className="flex items-center gap-1" data-id="element-182">
              <Shield className="w-4 h-4 text-gold" data-id="element-183" /> Garantía 7 días
            </div>
            <div className="flex items-center gap-1" data-id="element-184">
              <Lock className="w-4 h-4 text-gold" data-id="element-185" /> Pago seguro
            </div>
            <div className="flex items-center gap-1" data-id="element-186">
              <CreditCard className="w-4 h-4 text-gold" data-id="element-187" /> Múltiples medios
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}